import React from 'react';
import ProductPage from '../product_page/productPage';

const Search = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchValue = urlParams.get('query');

    let decodedSearchValue = '';
    if (searchValue != null) {
     decodedSearchValue = decodeURIComponent(searchValue);
    }

    const noSearchPhrase = 'No Search Phrase Entered';
    return <ProductPage
        page_title={decodedSearchValue === '' ? noSearchPhrase : ` "${decodedSearchValue}"`}
        initial_filters={{}}
        seo={{
            title: `${decodedSearchValue === '' ? noSearchPhrase : decodedSearchValue} - Search Results | The Sidewalk`,
            description: `Search results for ${decodedSearchValue === '' ? noSearchPhrase : `"${decodedSearchValue}"`}. Discover fashion from emerging brands like Tiger Mist, Levi's, Cotton On, and 33mm.`
        }}
    />;
};

export default Search;